import script from "./Shop.vue?vue&type=script&setup=true&lang=js"
export * from "./Shop.vue?vue&type=script&setup=true&lang=js"

import "./Shop.vue?vue&type=style&index=0&id=1c90cabf&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c90cabf"]])

export default __exports__